import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button } from '@material-ui/core';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textField': {
        width: '100%'
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#d8d8d8',
        margin: '20px 0',
    },
    '& .leaderTitle': {
        fontWeight: 'bold',
        color: '#0060A0',
        margin: '16px 0',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .members': {
        height: '265px',
        '& .member': {
            width: '48%',
            height: '100%',
            padding: '10px 20px',
            backgroundColor: '#F2F0F3',
        },
        '& .textField': {
            marginRight: '13px',
            backgroundColor: '#fff',
        },
    },
    '& .teamList': {
        height: '70%',
        overflow: 'auto',
        '& .item': {
            height: '24px',
            padding: '20px 0',
            borderBottom: '1px dashed #D8D8D8',
        },
        '& .delWapper': {
            cursor: 'pointer',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

const LEADER = "team_leader";
const MEMBER = "staff";
class TeamInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            description: "",
            selectLeaders: [],
            selectMembers: [],
        }
        this.handleCancel = this.handleCancel.bind(this);
    }
    render() {
        const { title } = this.props;
        const {
            name,
            description,
            selectLeaders,
            selectMembers,
        } = this.state;
        return (
            <Root>
                <div className="pageTitle">{title}</div>
                <div className="line"></div>
                <TextField
                    disabled={true}
                    className="textField"
                    id="outlined-name"
                    label="Team name"
                    value={name}
                    margin="dense"
                    variant="outlined"
                />
                <TextField
                    disabled={true}
                    className="textField"
                    id="outlined-multiline-static"
                    label="Description"
                    multiline
                    rows="3"
                    value={description}
                    margin="dense"
                    variant="outlined"
                />
                <div className="title">Team Members</div>
                <div className="members h h-bt">
                    <div className="member">
                        <div className="h h-l">
                            <div className="leaderTitle">Team Leader</div>
                        </div>
                        <div className="teamList">
                            {selectLeaders.map((item) => (
                                <div key={item.id} className="item h h-bt">
                                    <div>{item.first_name + " " + item.last_name}</div>
                                </div>
                            ))}

                        </div>
                    </div>
                    <div className="member">
                        <div className="h h-l">
                            <div className="leaderTitle">Team Member</div>
                        </div>
                        <div className="teamList">
                            {selectMembers.map((item) => (
                                <div key={item.id} className="item h h-bt">
                                    <div>{item.first_name + " " + item.last_name}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { data } = this.props;
        console.log(data)
        let temporaryData = data;
        if (temporaryData === null) {
            temporaryData = {
                name: "",
                description: "",
                members: [],
            }
        }
        this.setState(() => ({
            name: temporaryData.name,
            description: temporaryData.description,
            selectLeaders: this.filterRole(temporaryData.members, LEADER),
            selectMembers: this.filterRole(temporaryData.members, MEMBER),
        }))
    }
    handleCancel() {
        this.props.handleCancel();
    }
    //leader和member选择的内容
    handleSelect(e, name) {
        let value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    //name: role name字段
    filterRole(members, name) {
        if (members) {
            if (members.length <= 0) return [];
            let leaderArr = [];
            let memberArr = [];
            for (const obj of members) {
                let roleObj = obj.role;
                if (roleObj.name === LEADER) {
                    leaderArr.push(obj);
                } else {
                    memberArr.push(obj)
                }
            }
            if (name === LEADER) return leaderArr;
            if (name === MEMBER) return memberArr;
        }
        return [];
    }
}

export default TeamInfo;